export const SERVER_API_PREFIX = '@@serverApi/';
export const REQUEST_POSTFIX = '_REQUEST';
export const SUCCESS_POSTFIX = '_SUCCESS';
export const FAILURE_POSTFIX = '_FAILURE';

export const CHECK_CONNECTION = SERVER_API_PREFIX + 'CHECK_CONNECTION';
export const CHECK_CONNECTION_REQUEST = CHECK_CONNECTION + REQUEST_POSTFIX;
export const CHECK_CONNECTION_SUCCESS = CHECK_CONNECTION + SUCCESS_POSTFIX;
export const CHECK_CONNECTION_FAILURE = CHECK_CONNECTION + FAILURE_POSTFIX;

export const RESTAURANT = SERVER_API_PREFIX + 'RESTAURANT';
export const RESTAURANT_REQUEST = RESTAURANT + REQUEST_POSTFIX;
export const RESTAURANT_SUCCESS = RESTAURANT + SUCCESS_POSTFIX;
export const RESTAURANT_FAILURE = RESTAURANT + FAILURE_POSTFIX;

export const RESTAURANT_LIST = SERVER_API_PREFIX + 'RESTAURANT_LIST';
export const RESTAURANT_LIST_REQUEST = RESTAURANT_LIST + REQUEST_POSTFIX;
export const RESTAURANT_LIST_SUCCESS = RESTAURANT_LIST + SUCCESS_POSTFIX;
export const RESTAURANT_LIST_FAILURE = RESTAURANT_LIST + FAILURE_POSTFIX;

export const RESTAURANT_LIST_BY_ZIP = SERVER_API_PREFIX + 'RESTAURANT_LIST_BY_ZIP';
export const RESTAURANT_LIST_BY_ZIP_REQUEST = RESTAURANT_LIST_BY_ZIP + REQUEST_POSTFIX;
export const RESTAURANT_LIST_BY_ZIP_SUCCESS = RESTAURANT_LIST_BY_ZIP + SUCCESS_POSTFIX;
export const RESTAURANT_LIST_BY_ZIP_FAILURE = RESTAURANT_LIST_BY_ZIP + FAILURE_POSTFIX;

export const LOGIN_ANONYMOUS = SERVER_API_PREFIX + 'LOGIN_ANONYMOUS';
export const LOGIN_ANONYMOUS_REQUEST = LOGIN_ANONYMOUS + REQUEST_POSTFIX;
export const LOGIN_ANONYMOUS_SUCCESS = LOGIN_ANONYMOUS + SUCCESS_POSTFIX;
export const LOGIN_ANONYMOUS_FAILURE = LOGIN_ANONYMOUS + FAILURE_POSTFIX;

export const RESIGNUP = SERVER_API_PREFIX + 'RESIGNUP';
export const RESIGNUP_REQUEST = RESIGNUP + REQUEST_POSTFIX;
export const RESIGNUP_SUCCESS = RESIGNUP + SUCCESS_POSTFIX;
export const RESIGNUP_FAILURE = RESIGNUP + FAILURE_POSTFIX;

export const CUSTOMER = SERVER_API_PREFIX + 'CUSTOMER';
export const CUSTOMER_REQUEST = CUSTOMER + REQUEST_POSTFIX;
export const CUSTOMER_SUCCESS = CUSTOMER + SUCCESS_POSTFIX;
export const CUSTOMER_FAILURE = CUSTOMER + FAILURE_POSTFIX;

export const MENU = SERVER_API_PREFIX + 'MENU';
export const MENU_REQUEST = MENU + REQUEST_POSTFIX;
export const MENU_SUCCESS = MENU + SUCCESS_POSTFIX;
export const MENU_FAILURE = MENU + FAILURE_POSTFIX;

export const SERVER_CONFIG = SERVER_API_PREFIX + 'SERVER_CONFIG';
export const SERVER_CONFIG_REQUEST = SERVER_CONFIG + REQUEST_POSTFIX;
export const SERVER_CONFIG_SUCCESS = SERVER_CONFIG + SUCCESS_POSTFIX;
export const SERVER_CONFIG_FAILURE = SERVER_CONFIG + FAILURE_POSTFIX;

export const SERVER_CONFIG_BY_RESTAURANT = SERVER_API_PREFIX + 'SERVER_CONFIG_BY_RESTAURANT';
export const SERVER_CONFIG_BY_RESTAURANT_REQUEST = SERVER_CONFIG_BY_RESTAURANT + REQUEST_POSTFIX;
export const SERVER_CONFIG_BY_RESTAURANT_SUCCESS = SERVER_CONFIG_BY_RESTAURANT + SUCCESS_POSTFIX;
export const SERVER_CONFIG_BY_RESTAURANT_FAILURE = SERVER_CONFIG_BY_RESTAURANT + FAILURE_POSTFIX;

export const DISCOUNT = SERVER_API_PREFIX + 'DISCOUNT';
export const DISCOUNT_REQUEST = DISCOUNT + REQUEST_POSTFIX;
export const DISCOUNT_SUCCESS = DISCOUNT + SUCCESS_POSTFIX;
export const DISCOUNT_FAILURE = DISCOUNT + FAILURE_POSTFIX;

export const ORDER_DATES = SERVER_API_PREFIX + 'ORDER_DATES';
export const ORDER_DATES_REQUEST = ORDER_DATES + REQUEST_POSTFIX;
export const ORDER_DATES_SUCCESS = ORDER_DATES + SUCCESS_POSTFIX;
export const ORDER_DATES_FAILURE = ORDER_DATES + FAILURE_POSTFIX;

export const ORDER_TIME_SLOTS = SERVER_API_PREFIX + 'ORDER_TIME_SLOTS';
export const ORDER_TIME_SLOTS_REQUEST = ORDER_TIME_SLOTS + REQUEST_POSTFIX;
export const ORDER_TIME_SLOTS_SUCCESS = ORDER_TIME_SLOTS + SUCCESS_POSTFIX;
export const ORDER_TIME_SLOTS_FAILURE = ORDER_TIME_SLOTS + FAILURE_POSTFIX;

export const SET_PHONE = SERVER_API_PREFIX + 'SET_PHONE';
export const SET_PHONE_REQUEST = SET_PHONE + REQUEST_POSTFIX;
export const SET_PHONE_SUCCESS = SET_PHONE + SUCCESS_POSTFIX;
export const SET_PHONE_FAILURE = SET_PHONE + FAILURE_POSTFIX;

export const CHECK_PHONE_CODE = SERVER_API_PREFIX + 'CHECK_PHONE_CODE';
export const CHECK_PHONE_CODE_REQUEST = CHECK_PHONE_CODE + REQUEST_POSTFIX;
export const CHECK_PHONE_CODE_SUCCESS = CHECK_PHONE_CODE + SUCCESS_POSTFIX;
export const CHECK_PHONE_CODE_FAILURE = CHECK_PHONE_CODE + FAILURE_POSTFIX;

export const SEND_ORDER = SERVER_API_PREFIX + 'SEND_ORDER';
export const SEND_ORDER_REQUEST = SEND_ORDER + REQUEST_POSTFIX;
export const SEND_ORDER_SUCCESS = SEND_ORDER + SUCCESS_POSTFIX;
export const SEND_ORDER_FAILURE = SEND_ORDER + FAILURE_POSTFIX;

export const OLD_ORDERS = SERVER_API_PREFIX + 'OLD_ORDERS';
export const OLD_ORDERS_REQUEST = OLD_ORDERS + REQUEST_POSTFIX;
export const OLD_ORDERS_SUCCESS = OLD_ORDERS + SUCCESS_POSTFIX;
export const OLD_ORDERS_FAILURE = OLD_ORDERS + FAILURE_POSTFIX;

export const SET_LOCALE = SERVER_API_PREFIX + 'SET_LOCALE';
export const SET_LOCALE_REQUEST = SET_LOCALE + REQUEST_POSTFIX;
export const SET_LOCALE_SUCCESS = SET_LOCALE + SUCCESS_POSTFIX;
export const SET_LOCALE_FAILURE = SET_LOCALE + FAILURE_POSTFIX;

export const SET_NAME = SERVER_API_PREFIX + 'SET_NAME';
export const SET_NAME_REQUEST = SET_NAME + REQUEST_POSTFIX;
export const SET_NAME_SUCCESS = SET_NAME + SUCCESS_POSTFIX;
export const SET_NAME_FAILURE = SET_NAME + FAILURE_POSTFIX;

export const SET_EMAIL = SERVER_API_PREFIX + 'SET_EMAIL';
export const SET_EMAIL_REQUEST = SET_EMAIL + REQUEST_POSTFIX;
export const SET_EMAIL_SUCCESS = SET_EMAIL + SUCCESS_POSTFIX;
export const SET_EMAIL_FAILURE = SET_EMAIL + FAILURE_POSTFIX;

export const SET_BIRTHDATE = SERVER_API_PREFIX + 'SET_BIRTHDATE';
export const SET_BIRTHDATE_REQUEST = SET_BIRTHDATE + REQUEST_POSTFIX;
export const SET_BIRTHDATE_SUCCESS = SET_BIRTHDATE + SUCCESS_POSTFIX;
export const SET_BIRTHDATE_FAILURE = SET_BIRTHDATE + FAILURE_POSTFIX;

export const CASHPOINTS = SERVER_API_PREFIX + 'CASHPOINTS';
export const CASHPOINTS_REQUEST = CASHPOINTS + REQUEST_POSTFIX;
export const CASHPOINTS_SUCCESS = CASHPOINTS + SUCCESS_POSTFIX;
export const CASHPOINTS_FAILURE = CASHPOINTS + FAILURE_POSTFIX;

export const CHECK_ZIP = SERVER_API_PREFIX + 'CHECK_ZIP';
export const CHECK_ZIP_REQUEST = CHECK_ZIP + REQUEST_POSTFIX;
export const CHECK_ZIP_SUCCESS = CHECK_ZIP + SUCCESS_POSTFIX;
export const CHECK_ZIP_FAILURE = CHECK_ZIP + FAILURE_POSTFIX;

export const APPLY_PROMOCODE = SERVER_API_PREFIX + 'APPLY_PROMOCODE';
export const APPLY_PROMOCODE_REQUEST = APPLY_PROMOCODE + REQUEST_POSTFIX;
export const APPLY_PROMOCODE_SUCCESS = APPLY_PROMOCODE + SUCCESS_POSTFIX;
export const APPLY_PROMOCODE_FAILURE = APPLY_PROMOCODE + FAILURE_POSTFIX;

export const SET_TABLE = SERVER_API_PREFIX + 'SET_TABLE';
export const SET_TABLE_REQUEST = SET_TABLE + REQUEST_POSTFIX;
export const SET_TABLE_SUCCESS = SET_TABLE + SUCCESS_POSTFIX;
export const SET_TABLE_FAILURE = SET_TABLE + FAILURE_POSTFIX;

export const CHECK_PAYMENT_STATUS = SERVER_API_PREFIX + 'CHECK_PAYMENT_STATUS';
export const CHECK_PAYMENT_STATUS_REQUEST = CHECK_PAYMENT_STATUS + REQUEST_POSTFIX;
export const CHECK_PAYMENT_STATUS_SUCCESS = CHECK_PAYMENT_STATUS + SUCCESS_POSTFIX;
export const CHECK_PAYMENT_STATUS_FAILURE = CHECK_PAYMENT_STATUS + FAILURE_POSTFIX;

export const ORDER = SERVER_API_PREFIX + 'ORDER';
export const ORDER_REQUEST = ORDER + REQUEST_POSTFIX;
export const ORDER_SUCCESS = ORDER + SUCCESS_POSTFIX;
export const ORDER_FAILURE = ORDER + FAILURE_POSTFIX;

export const DELETE_CARD = SERVER_API_PREFIX + 'DELETE_CARD';
export const DELETE_CARD_REQUEST = DELETE_CARD + REQUEST_POSTFIX;
export const DELETE_CARD_SUCCESS = DELETE_CARD + SUCCESS_POSTFIX;
export const DELETE_CARD_FAILURE = DELETE_CARD + FAILURE_POSTFIX;

export const EMAIL_RECEIPTS = SERVER_API_PREFIX + 'EMAIL_RECEIPTS';
export const EMAIL_RECEIPTS_REQUEST = EMAIL_RECEIPTS + REQUEST_POSTFIX;
export const EMAIL_RECEIPTS_SUCCESS = EMAIL_RECEIPTS + SUCCESS_POSTFIX;
export const EMAIL_RECEIPTS_FAILURE = EMAIL_RECEIPTS + FAILURE_POSTFIX;

export const SEND_RECEIPT = SERVER_API_PREFIX + 'SEND_RECEIPT';
export const SEND_RECEIPT_REQUEST = SEND_RECEIPT + REQUEST_POSTFIX;
export const SEND_RECEIPT_SUCCESS = SEND_RECEIPT + SUCCESS_POSTFIX;
export const SEND_RECEIPT_FAILURE = SEND_RECEIPT + FAILURE_POSTFIX;

export const RESEND_PHONE_CODE = SERVER_API_PREFIX + 'RESEND_PHONE_CODE';
export const RESEND_PHONE_CODE_REQUEST = RESEND_PHONE_CODE + REQUEST_POSTFIX;
export const RESEND_PHONE_CODE_SUCCESS = RESEND_PHONE_CODE + SUCCESS_POSTFIX;
export const RESEND_PHONE_CODE_FAILURE = RESEND_PHONE_CODE + FAILURE_POSTFIX;

export const ALLOW_MARKETING = SERVER_API_PREFIX + 'ALLOW_MARKETING';
export const ALLOW_MARKETING_REQUEST = ALLOW_MARKETING + REQUEST_POSTFIX;
export const ALLOW_MARKETING_SUCCESS = ALLOW_MARKETING + SUCCESS_POSTFIX;
export const ALLOW_MARKETING_FAILURE = ALLOW_MARKETING + FAILURE_POSTFIX;

export const REGISTER_STRIPE_CARD = SERVER_API_PREFIX + 'REGISTER_STRIPE_CARD';
export const REGISTER_STRIPE_CARD_REQUEST = REGISTER_STRIPE_CARD + REQUEST_POSTFIX;
export const REGISTER_STRIPE_CARD_SUCCESS = REGISTER_STRIPE_CARD + SUCCESS_POSTFIX;
export const REGISTER_STRIPE_CARD_FAILURE = REGISTER_STRIPE_CARD + FAILURE_POSTFIX;

export const LOCALIZATION = SERVER_API_PREFIX + 'LOCALIZATION';
export const LOCALIZATION_REQUEST = LOCALIZATION + REQUEST_POSTFIX;
export const LOCALIZATION_SUCCESS = LOCALIZATION + SUCCESS_POSTFIX;
export const LOCALIZATION_FAILURE = LOCALIZATION + FAILURE_POSTFIX;

export const ACCEPT_TERMS = SERVER_API_PREFIX + 'ACCEPT_TERMS';
export const ACCEPT_TERMS_REQUEST = ACCEPT_TERMS + REQUEST_POSTFIX;
export const ACCEPT_TERMS_SUCCESS = ACCEPT_TERMS + SUCCESS_POSTFIX;
export const ACCEPT_TERMS_FAILURE = ACCEPT_TERMS + FAILURE_POSTFIX;

export const SEND_CLIENT_LOG = SERVER_API_PREFIX + 'SEND_CLIENT_LOG';
export const SEND_CLIENT_LOG_REQUEST = SEND_CLIENT_LOG + REQUEST_POSTFIX;
export const SEND_CLIENT_LOG_SUCCESS = SEND_CLIENT_LOG + SUCCESS_POSTFIX;
export const SEND_CLIENT_LOG_FAILURE = SEND_CLIENT_LOG + FAILURE_POSTFIX;

export const CANCEL_ORDER = SERVER_API_PREFIX + 'CANCEL_ORDER';
export const CANCEL_ORDER_REQUEST = CANCEL_ORDER + REQUEST_POSTFIX;
export const CANCEL_ORDER_SUCCESS = CANCEL_ORDER + SUCCESS_POSTFIX;
export const CANCEL_ORDER_FAILURE = CANCEL_ORDER + FAILURE_POSTFIX;

export const MARK_POPUP_AS_SHOWN = SERVER_API_PREFIX + 'MARK_POPUP_AS_SHOWN';
export const MARK_POPUP_AS_SHOWN_REQUEST = MARK_POPUP_AS_SHOWN + REQUEST_POSTFIX;
export const MARK_POPUP_AS_SHOWN_SUCCESS = MARK_POPUP_AS_SHOWN + SUCCESS_POSTFIX;
export const MARK_POPUP_AS_SHOWN_FAILURE = MARK_POPUP_AS_SHOWN + FAILURE_POSTFIX;

export const GET_HISTORY_ORDERS = SERVER_API_PREFIX + 'GET_HISTORY_ORDERS';
export const GET_HISTORY_ORDERS_REQUEST = GET_HISTORY_ORDERS + REQUEST_POSTFIX;
export const GET_HISTORY_ORDERS_SUCCESS = GET_HISTORY_ORDERS + SUCCESS_POSTFIX;
export const GET_HISTORY_ORDERS_FAILURE = GET_HISTORY_ORDERS + FAILURE_POSTFIX;

export const REPEAT_ORDER = SERVER_API_PREFIX + 'REPEAT_ORDER';
export const REPEAT_ORDER_REQUEST = REPEAT_ORDER + REQUEST_POSTFIX;
export const REPEAT_ORDER_SUCCESS = REPEAT_ORDER + SUCCESS_POSTFIX;
export const REPEAT_ORDER_FAILURE = REPEAT_ORDER + FAILURE_POSTFIX;

export const INIT_ADYEN_PAYMENT = SERVER_API_PREFIX + 'INIT_ADYEN_PAYMENT';
export const INIT_ADYEN_PAYMENT_REQUEST = INIT_ADYEN_PAYMENT + REQUEST_POSTFIX;
export const INIT_ADYEN_PAYMENT_SUCCESS = INIT_ADYEN_PAYMENT + SUCCESS_POSTFIX;
export const INIT_ADYEN_PAYMENT_FAILURE = INIT_ADYEN_PAYMENT + FAILURE_POSTFIX;

export const REGISTER_ADYEN_CARD = SERVER_API_PREFIX + 'REGISTER_ADYEN_CARD';
export const REGISTER_ADYEN_CARD_REQUEST = REGISTER_ADYEN_CARD + REQUEST_POSTFIX;
export const REGISTER_ADYEN_CARD_SUCCESS = REGISTER_ADYEN_CARD + SUCCESS_POSTFIX;
export const REGISTER_ADYEN_CARD_FAILURE = REGISTER_ADYEN_CARD + FAILURE_POSTFIX;

export const CHECK_ADYEN_PAYMENT = SERVER_API_PREFIX + 'CHECK_ADYEN_PAYMENT';
export const CHECK_ADYEN_PAYMENT_REQUEST = CHECK_ADYEN_PAYMENT + REQUEST_POSTFIX;
export const CHECK_ADYEN_PAYMENT_SUCCESS = CHECK_ADYEN_PAYMENT + SUCCESS_POSTFIX;
export const CHECK_ADYEN_PAYMENT_FAILURE = CHECK_ADYEN_PAYMENT + FAILURE_POSTFIX;

export const SUBMIT_SWISH_PAY = SERVER_API_PREFIX + 'SUBMIT_SWISH_PAY';
export const SUBMIT_SWISH_PAY_REQUEST = SUBMIT_SWISH_PAY + REQUEST_POSTFIX;
export const SUBMIT_SWISH_PAY_SUCCESS = SUBMIT_SWISH_PAY + SUCCESS_POSTFIX;
export const SUBMIT_SWISH_PAY_FAILURE = SUBMIT_SWISH_PAY + FAILURE_POSTFIX;


export const CHECK_PAYMENT_STATUS_ANONYMOUSLY = SERVER_API_PREFIX + 'CHECK_PAYMENT_STATUS_ANONYMOUSLY';
export const CHECK_PAYMENT_STATUS_ANONYMOUSLY_REQUEST = CHECK_PAYMENT_STATUS_ANONYMOUSLY + REQUEST_POSTFIX;
export const CHECK_PAYMENT_STATUS_ANONYMOUSLY_SUCCESS = CHECK_PAYMENT_STATUS_ANONYMOUSLY + SUCCESS_POSTFIX;
export const CHECK_PAYMENT_STATUS_ANONYMOUSLY_FAILURE = CHECK_PAYMENT_STATUS_ANONYMOUSLY + FAILURE_POSTFIX;

export const SUBMIT_GOOGLE_PAY = SERVER_API_PREFIX + 'SUBMIT_GOOGLE_PAY';
export const SUBMIT_GOOGLE_PAY_REQUEST = SUBMIT_GOOGLE_PAY + REQUEST_POSTFIX;
export const SUBMIT_GOOGLE_PAY_SUCCESS = SUBMIT_GOOGLE_PAY + SUCCESS_POSTFIX;
export const SUBMIT_GOOGLE_PAY_FAILURE = SUBMIT_GOOGLE_PAY + FAILURE_POSTFIX;

export const SUBMIT_APPLE_PAY = SERVER_API_PREFIX + 'SUBMIT_APPLE_PAY';
export const SUBMIT_APPLE_PAY_REQUEST = SUBMIT_APPLE_PAY + REQUEST_POSTFIX;
export const SUBMIT_APPLE_PAY_SUCCESS = SUBMIT_APPLE_PAY + SUCCESS_POSTFIX;
export const SUBMIT_APPLE_PAY_FAILURE = SUBMIT_APPLE_PAY + FAILURE_POSTFIX;

export const SET_GUEST = SERVER_API_PREFIX + 'SET_GUEST';
export const SET_GUEST_REQUEST = SET_GUEST + REQUEST_POSTFIX;
export const SET_GUEST_SUCCESS = SET_GUEST + SUCCESS_POSTFIX;
export const SET_GUEST_FAILURE = SET_GUEST + FAILURE_POSTFIX;
